import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { host } from "../../api/ApiCalls";
import { getBase64Image } from "../../utils/imageHelper";
import { Star, Users, DollarSign } from "lucide-react";
import Lottie from "lottie-react";
import Loading from "../../assets/Loading.json"

const TeacherProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);
 useEffect(() => {
  const fetchTeacher = async () => {
    try {
      const response = await axios.get(`${host}/api/teachers/${id}`);
      setTeacher(response.data);
      
      console.log("Teacher data:", response.data);
    } catch (error) {
      console.error("Error fetching teacher:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchTeacher();
}, [id]);

const uniqueStudentCount = new Set(
  teacher?.offeredCourses?.flatMap(course => 
    course.students?.map(student => student.student)
  )
).size;

  if (loading) {
    return (
      <div className="flex items-center justify-center text-gray-800 m-8">
        <div className="w-80">
          <Lottie animationData={Loading} loop={true} />
        </div>
      </div>
    );
  }
  if (!teacher)
    return <div className="text-center py-20">Teacher not found</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 🔹 Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col md:flex-row items-center gap-10">
          <img
            src={teacher.avatar}
            alt={teacher.name}
            className="w-40 h-40 rounded-full object-cover border-4 border-white shadow-xl"
          />
          <div className="text-white text-center md:text-left">
            <h1 className="text-4xl font-bold">{teacher.name}</h1>
            <p className="text-lg text-indigo-200 mt-1">
              {teacher.subjects?.join(", ")}
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-4">
              <div className="flex items-center">
                <Star className="h-5 w-5 text-yellow-400" />
                <span className="ml-1">
                  {teacher.rating} 
                </span>
              </div>
              <div className="flex items-center">
                <Users className="h-5 w-5" />
                <span className="ml-1">{uniqueStudentCount} students</span>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Offered Courses Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Offered Courses</h2>

        {teacher.offeredCourses.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {teacher.offeredCourses.map((course) => (
              <div
                key={course._id}
                className="bg-white shadow-md rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 cursor-pointer"
                onClick={() => navigate(`/courses/${course._id}`)}
              >
                <img
                  src={course.image || "https://via.placeholder.com/300"}
                  alt={course.title}
                  className="w-full h-40 object-cover"
                />
                <div className="p-4">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {course.title}
                  </h3>
                  <p className="text-gray-600 mt-1">{course.description}</p>
                  <div className="mt-3 flex items-center text-gray-700">
                    <DollarSign className="h-4 w-4 mr-1" />
                    <span>{course.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No courses available.</p>
        )}
      </div>
    </div>
  );
};

export default TeacherProfile;
